import { useMemo, useState } from "react";

import { Button, Grid, MenuItem, Select, Typography } from "@material-ui/core";

import { GqlRecordPicker } from "..";
import { QUERIES } from "../../../graphql";
import {
  AmenityDefinition,
  ServiceCompatiblePlace,
  ServiceCompatiblePlaceAmenity,
  ServiceCompatiblePlaceType,
  serviceCompatiblePlaceTypes,
} from "../../../graphql/models";

import useCompatiblePlaceEditorStyles from "./compatible_place_editor.style";

export interface CompatiblePlaceEditorProps {
  compatiblePlace?: ServiceCompatiblePlace;
  onCompatiblePlaceChange: (el: ServiceCompatiblePlace) => void;
}

export function CompatiblePlaceEditor(props: CompatiblePlaceEditorProps) {
  const { compatiblePlace, onCompatiblePlaceChange } = props;

  const [readonly, setReadonly] = useState(false);
  const [type, setType] = useState<ServiceCompatiblePlaceType>(
    compatiblePlace?.type ?? ServiceCompatiblePlaceType.AMENITY
  );
  console.log("type is", type);
  const [amenity, setAmenity] = useState<
    ServiceCompatiblePlaceAmenity | undefined
  >(compatiblePlace?.amenity);

  const isAmenity = useMemo(() => {
    return type === ServiceCompatiblePlaceType.AMENITY;
  }, [type]);

  const triggerSetReadonly = () => {
    if (readonly) {
      setReadonly(false);
    } else {
      setReadonly(true);
      onCompatiblePlaceChange({
        type,
        amenity,
      });
    }
  };

  const classes = useCompatiblePlaceEditorStyles();

  return (
    <Grid container spacing={3} style={{ width: "100%" }}>
      <Grid item xs={12} md={12}>
        <Typography variant="caption">Tipologia</Typography>
        <Select
          className={classes.width100}
          variant="outlined"
          defaultValue={Number(type)}
          onChange={(evt) => setType(Number(evt.target.value))}
        >
          {Object.entries(serviceCompatiblePlaceTypes).map(([key, value]) => (
            <MenuItem value={Number(key)} selected={Number(key) === type}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      {isAmenity && (
        <Grid item xs={12} xl={12}>
          <GqlRecordPicker
            // disabled={disabled || loading}}
            className={classes.width100}
            multiple={false}
            value={amenity}
            getOptionLabel={(record) => record.name}
            placeHolder={"Amenity"}
            renderOption={(record) => record.name}
            onValueChange={(value: AmenityDefinition) =>
              setAmenity({
                id: value.id,
                name: value.name,
              })
            }
            query={QUERIES.AMENITIES_DEFINITIONS}
            queryResultDataField={"amenitiesDefinitions"}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <Button className={classes.width100} onClick={triggerSetReadonly}>
          {readonly ? "Modifica" : "Conferma"}
        </Button>
      </Grid>
    </Grid>
  );
}
